import './App.css';
import SignatureCapturePage from './pages/SignatureCapturePage';

function App() {
  return (
    <SignatureCapturePage />
  );
}

export default App;
